import MasterDataReducer from './reducer';

export { default as masterDataSelectors } from './selectors';
export { default as masterDataActions } from './actions';

export default MasterDataReducer;
